import React from 'react';
import { Route } from 'react-router-dom';
import TestimonialSection from '../pages/testimonials/TestimonialSection';
import Testimonials from '../pages/testimonials/Testimonials';
import CreateTestimonial from '../pages/testimonials/CreateTestimonial';
import EditTestimonial from '../pages/testimonials/EditTestimonial';
import ProtectedRoute from '../components/global/ProtectedRoute';

const testimonialsRoutes = (
    <>
        <Route
            path="/testimonials/section"
            element={
                <ProtectedRoute requiredPermission="viewAny-testimonial-section">
                    <TestimonialSection />
                </ProtectedRoute>
            }
        />

        <Route
            path="/testimonials"
            element={
                <ProtectedRoute requiredPermission="viewAny-testimonial">
                    <Testimonials />
                </ProtectedRoute>
            }
        />

        <Route
            path="/testimonials/create"
            element={
                <ProtectedRoute requiredPermission="create-testimonial">
                    <CreateTestimonial />
                </ProtectedRoute>
            }
        />

        <Route
            path="/testimonials/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-testimonial">
                    <EditTestimonial />
                </ProtectedRoute>
            }
        />
    </>
);

export default testimonialsRoutes;
